export const GET_CART_ITEMS="GET_CART_ITEMS";
export const ADD_CART_ITEMS="ADD_CART_ITEMS";
export const ADD_CART_ITEMS_FAILURE="ADD_CART_ITEMS_FAILURE"
export const CHANGE_CART_ITEMS="CHANGE_CART_ITEMS";
export const REMOVE_CART_ITEMS="REMOVE_CART_ITEMS";
